export default {
    routerName: '文章編集',
    routerNamePic: '画像カットアウト',
    article: {
        title: 'タイトル',
        description: '記述',
        body: '詳細',
        author: '作者',
        tag: 'タグ',
        tagName: 'タグ名',
        status: '状態',
        status0: '下書き',
        status1: '審査失敗',
        status2: '審査中',
        status9: '審査成功',
        charge: '有无料',
        charge0: '有料',
        charge1: '无料',
        disabled: '無効',
        yes: 'はい',
        no: 'いいえ',
        thumb: 'サムネイル',
        image: '画像',
        default: ' デフォルト',
        category: 'カテゴリー',
        hot: 'ホットニュース',
        recommend: 'おすすめ記事',
        recommendTop: '推薦TOP',
        top: '詳細トプ',
        topic: 'トピック',
        slider: 'スライド',
        hits: '閲覧量',
        version: 'バージョン',
        releaseTime: 'リリース日付',
    },
    menu: {
        title: 'メニュー配分',
        name: 'メニュー',
        setting: '詳細設定',
    },
};
